import React, { Component } from 'react';
import {Redirect} from "react-router-dom";
import axios from 'axios';
import FormTextItem from "./FormTextItem";
import SecurityPlanService from "../services/SecurityPlan.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class PagRazones extends Component {
    state = {
        items: [],
        isLoggedIn: false,
        firstTime: true,
    };

    async componentDidMount(){  
        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({ isLoggedIn: response.data.isLoggedIn, firstTime: false });  

        if(response.data.isLoggedIn){
            const response = await SecurityPlanService.get();
            if (response.status !== 200) {
                alert(`Error: ${response.data.message}`);
            } else {
                this.setState({items: response.data.items});;
            }
        }
    }

    render() {
        return (this.state.isLoggedIn || this.state.firstTime)
        ?(
            <React.Fragment>
                <FormTextItem
                    idCategory={5}
                    items={this.state.items}
                    title="Mis razones para vivir"
                    description="Todas las personas tenemos razones que nos motivan a vivir, incluso cuando estamos
                    atravesando situaciones muy difíciles. Pueden ser del pasado, del presente o del futuro. Pueden
                    tener que ver con personas que querés, con la situación que estás viviendo, con proyectos personales
                    tuyos, tus mascotas o con tus creencias.
                    Tratá de pensar y escribí las razones que se ocurran para vivir. También podes poner links de videos
                    de Youtube.
                    Te ponemos algunas de ejemplo:"
                />
            </React.Fragment>
        ) 
        :<Redirect to="/" />
    }
}
